/**
 * HM-387 cluster login PIN: top bar dello Step 2 — mostra operatore selezionato
 * + bottone "indietro" per tornare alla griglia Step 1 (cambia utente senza
 * uscire dal flow login).
 */
import type { Operator } from '../../api/auth.js';

const ROLE_LABEL: Record<Operator['role'], string> = {
  admin: 'Admin',
  reception: 'Reception',
  housekeeping: 'Housekeeping',
  owner: 'Owner',
};

export function SelectedOperatorBar({
  operator,
  onBack,
}: {
  operator: Operator;
  onBack: () => void;
}) {
  const isAdminLike = operator.role === 'admin' || operator.role === 'owner';
  return (
    <div className="selected-operator-bar">
      <div className={`operator-avatar ${isAdminLike ? 'admin' : 'reception'}`}>
        {operator.initials}
      </div>
      <div className="selected-operator-info">
        <div className="selected-operator-name">{operator.displayName}</div>
        <div className={`selected-operator-role ${isAdminLike ? 'admin' : 'reception'}`}>
          {ROLE_LABEL[operator.role] ?? operator.role}
        </div>
      </div>
      <button
        type="button"
        className="change-user-btn"
        onClick={onBack}
        aria-label="Cambia operatore"
        data-testid="back-to-grid"
      >
        ←
      </button>
    </div>
  );
}
